import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { useTaskCategory, TaskCategory } from './useData';
import {
  moduleConfig,
  getInitialFormData,
  mapItemToFormData,
} from './config';

const Form: React.FC = () => {
  return (
    <GenericFormPage<TaskCategory>
      useData={useTaskCategory}
      config={{
        ...moduleConfig,
        getInitialFormData,
        mapItemToFormData,
      }}
    />
  );
};

export default Form;
